var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "modal",
    {
      attrs: {
        "append-to-body": true,
        title: _vm.$t("NUMBER_SELECT_AFFILIATE"),
        footer: false
      },
      on: {
        hide: function($event) {
          return _vm.$emit("cancel")
        }
      },
      model: {
        value: _vm.isActive,
        callback: function($$v) {
          _vm.isActive = $$v
        },
        expression: "isActive"
      }
    },
    [
      _c(
        "form",
        {
          staticClass: "form-horizontal",
          attrs: { role: "form", name: _vm.formName, novalidate: "" }
        },
        [
          _c("fieldset", [
            _c("div", { staticClass: "container-fluid" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "NUMBER_SELECT_AFFILIATE_NUMBER",
                      expression: "'NUMBER_SELECT_AFFILIATE_NUMBER'"
                    }
                  ],
                  staticClass: "col-sm-2 col-md-3 control-label"
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-sm-9 form-control-static text-bold" },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.selectedNumber.phoneNumber) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "NUMBER_SELECT_AFFILIATE_PUBLISHER",
                      expression: "'NUMBER_SELECT_AFFILIATE_PUBLISHER'"
                    }
                  ],
                  staticClass: "col-sm-2 col-md-3 control-label"
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-sm-6 col-md-5" },
                  [
                    _c("SearchableDropdown", {
                      attrs: { config: _vm.affiliatesListConfig },
                      model: {
                        value: _vm.selectedAffiliate,
                        callback: function($$v) {
                          _vm.selectedAffiliate = $$v
                        },
                        expression: "selectedAffiliate"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group text-align-right" },
                [
                  _c(
                    "PrimaryButton",
                    { attrs: { "do-on-click": _vm._onSubmit } },
                    [
                      _c("span", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "NUMBER_SELECT_AFFILIATE_ADD_PUBLISHER",
                            expression:
                              "'NUMBER_SELECT_AFFILIATE_ADD_PUBLISHER'"
                          }
                        ]
                      })
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }